import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { ID } from "@common/interfaces/id";
import { IID_CHECKLIST_GISFO } from "@common/interfaces/interfaceData";
import { Topics } from "@common/interfaces/topics";
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIDChecklistGISFOState extends EntityState<IID_CHECKLIST_GISFO, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_CHECKLIST_GISFO , realtimeEntity: 'IID_ChecklistGisfo'})
@InterfaceDataStore(InterfaceName.CHECKLIST_GISFO)
export class IIDChecklistGISFOStore extends EntityStore<IIDChecklistGISFOState> {
  constructor() {
    super([]);
  }
}
